import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import PageWrapper from "../../components/common/layout/PageWrapper";
import HERecognitionView from "../../components/services/higherEducation/HERecognitionView";
import { baseEndpointPaths, getApplicationForCheckup } from "../../../services/serviceCalls";
import SERecognitionViewPage from "./SERecognitionViewPage";
import SEApplicationView from "../../components/services/secondaryEducation/SEApplicationView";

const SeRecognitionCheckupPage = ({ titleCode }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const dossierNumber = searchParams.get("dossierNumber");
  const accessCode = searchParams.get("accessCode");
  const captchaToken = searchParams.get("captchaToken");

  return (
    <PageWrapper title={t(`${titleCode}.view`)}>
      <SEApplicationView
        serviceFn={getApplicationForCheckup(baseEndpointPaths.seRecognition, dossierNumber, accessCode, captchaToken)}
      />
    </PageWrapper>
  );
};
export default SeRecognitionCheckupPage;
